import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function FeaturedHero({ article }) {
  if (!article) return null;
  return (
    <Link
      to={`/news/${article.id}`}
      data-testid="featured-hero"
      className="group relative block overflow-hidden border border-white/10 bg-[#0a0a0b] h-[480px] md:h-[560px]"
    >
      {article.image_url && (
        <img
          src={article.image_url}
          alt={article.title}
          className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/10" />
      <div className="absolute inset-0 flex items-end p-8 md:p-12">
        <div className="max-w-3xl fade-up">
          <span className="inline-block px-3 py-1 text-xs font-mono uppercase tracking-[0.2em] bg-yellow-400 text-black mb-6">
            Featured · {article.category_slug?.replace("-", " ") || "News"}
          </span>
          <h1 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05] tracking-tight">
            {article.title}
          </h1>
          {article.excerpt && (
            <p className="mt-5 text-lg md:text-xl text-zinc-300 max-w-2xl leading-relaxed">
              {article.excerpt}
            </p>
          )}
          <div className="mt-8 flex items-center gap-4">
            <span className="font-mono text-xs text-zinc-400 uppercase tracking-widest">
              {article.author_name || "HashRate"} · {new Date(article.created_at).toLocaleDateString()}
            </span>
            <ArrowUpRight className="w-5 h-5 text-yellow-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition" />
          </div>
        </div>
      </div>
    </Link>
  );
}
